import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { ElioHasPermissionModule } from '@elio/emanager-front/shared/directives';
import { ElioButtonComponent } from '@elio/emanager-front/shared/ui/button';
import { ElioSvgIconsModule } from '@elio/shared/icon-utils';
import { vSlideInOut } from '@elio/shared/utils';
import { TranslocoModule } from '@ngneat/transloco';
import { LetDirective, PushPipe } from '@ngrx/component';
import { ComponentStore } from '@ngrx/component-store';
import { TooltipModule } from 'primeng/tooltip';
import { FILTERABLE_STORE, FilterableStore, FilterableType } from '../filter.token';
import { ElioFiltersComponent } from '../filters/filters.component';

interface FilterSmallState {
  isOpen: boolean;
}

@Component({
  selector: 'elio-filters-small',
  templateUrl: './filters-small.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ElioButtonComponent,
    ElioHasPermissionModule,
    ElioFiltersComponent,
    ElioSvgIconsModule,
    LetDirective,
    PushPipe,
    TooltipModule,
    TranslocoModule,
  ],
  host: { class: 'relative' },
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [vSlideInOut(400)],
})
export class ElioFiltersSmallComponent<T extends FilterableType> extends ComponentStore<FilterSmallState> {
  readonly isOpen$ = this.select((state) => state.isOpen);
  readonly size$ = this.filterableStore.activeFiltersSize$;

  constructor(@Inject(FILTERABLE_STORE) private filterableStore: FilterableStore<T>) {
    super({ isOpen: false });
  }

  readonly close = this.updater((state): FilterSmallState => ({ ...state, isOpen: false }));
  readonly open = this.updater((state): FilterSmallState => ({ ...state, isOpen: true }));
}
